'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Card } from 'react-bootstrap';
const uuid = require('uuid');

const _ = {
    find: require('lodash/find'),
    forEach: require('lodash/forEach'),
    map: require('lodash/map'),
};

const Globals = require('../../../../app/globals');

const RSDActions = require('../../actions/RSDActions');
const RSDStore = require('../../stores/RSDStore');

import SortableTable2 from '../table/SortableTable2';
import AccessibleIcon from '../common/AccessibleIcon';
import ExpandableWell from '../common/ExpandableWell';

const propTypes = {
    serviceData: PropTypes.object,
    closeHandler: PropTypes.func.isRequired,
};

const defaultProps = {
    show: true,
};

class OrgEditRSDsModal extends React.Component {
    constructor(props) {
        super(props);
        let rsdState = this.getRSDState(props);
        this.state = {
            selected_rsd_id: '',
            name: '',
            description: '',
            ...rsdState,
            rsd_changes: {},
        };
        this.unsubscribes = [
            RSDStore.listen(this.onRSDStoreChange.bind(this)),
        ];
    }
    
    componentDidMount() {
        if (!this.state.initialized) {
            RSDActions.getOrgServiceRSDs(uuid.v4(),{orgId: this.props.orgId, rsd_service_id: this.props.serviceData.id});
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    getRSDState=(props)=>{
        let rsds=[];
        let initialized = false;
        const rsd_service_id = props.serviceData.id;
        const rsdStoreState = RSDStore.getStateOrg(props.orgId);
        console.log("rsdStoreState",rsdStoreState); // FIXME: remove debug spam
        if (rsdStoreState.rsds && rsdStoreState.rsds[rsd_service_id]) {
            rsds = rsdStoreState.rsds[rsd_service_id];
        }
        return { initialized, rsds };
    }

    onRSDStoreChange=(storeState)=>{
        let rsdState = this.getRSDState(this.props);
        let changes = {...rsdState};
        if (storeState.action) {
            if (storeState.action.id === this.state.add_actionId) {
                changes = {...changes, add_actionId: null, name: '', description: '', showAddSection: false };
            }
            if (storeState.action.id === this.state.update_actionId) {
                changes = {...changes, update_actionId: null };
            }
        }
        this.setState(changes);
    }
    
    setRowEdit=(id,key,value)=>{
        let rsd_changes = {...this.state.rsd_changes};
        if( !rsd_changes[id] ) {
            rsd_changes[id] = {[key]: value};
        }
        else {
            rsd_changes[id][key] = value;
        }
        this.setState({rsd_changes});
    }
    
    saveRowEdit=(id)=>{
        let rsd = _.find(this.state.rsds,{id});
        let change = this.state.rsd_changes[id];
        let rsd_changes = {...this.state.rsd_changes};
        delete rsd_changes[id];
        if (rsd && change) {
            let changes = {};
            let anyChanges = false;
            if (typeof change.name !== 'undefined') {
                if (rsd.name !== change.name) {
                    anyChanges = true;
                    changes.name = change.name;
                }
            }
            if (typeof change.description !== 'undefined') {
                if (rsd.description !== change.description) {
                    anyChanges = true;
                    changes.description = change.description;
                }
            }
            if (anyChanges) {
                const rsd_service_id = this.props.serviceData.id;
                let update_actionId = uuid.v4();
                let params = {
                    orgId: this.props.orgId, 
                    rsd_service_id,
                    rsd_id: id,
                    ...changes 
                };
                this.setState({update_actionId,rsd_changes},()=>{
                    RSDActions.updateRSD(update_actionId,params);
                });
            }
            else {
                this.setState({rsd_changes});
            }
        }
    }
    
    clearRowEdit=(id)=>{
        let rsd_changes = {...this.state.rsd_changes};
        delete rsd_changes[id];
        this.setState({rsd_changes});
    }

    onRowClick=(id)=>{
        let rsd = _.find(this.state.rsds, {id});
        if (rsd) {
            // copy rsd_id to clipboard
            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(rsd.id);
            }
        }
    }

    addRSD=()=>{
        if (!this.state.add_actionId) {
            const rsd_service_id = this.props.serviceData.id;
            let add_actionId = uuid.v4();
            let params = {
                orgId: this.props.orgId, 
                rsd_service_id, 
                name: this.state.name, 
                description: this.state.description
            };
            this.setState({add_actionId},()=>{
                RSDActions.addRSD(add_actionId,params);
            });
        }
    }

    render() {
        let rows = _.map(this.state.rsds,(rsd)=>({
            ...rsd, dirty: false
        }))
        _.forEach(this.state.rsd_changes,(change,id)=>{
            let r = _.find(rows,{id});
            if (r) {
                r.dirty = false;
                if (typeof change.name !== 'undefined') {
                    if (r.name !== change.name) {
                        r.dirty = true;
                        r.name = change.name;
                    }
                }
                if (typeof change.description !== 'undefined') {
                    if (r.description !== change.description) {
                        r.dirty = true;
                        r.description = change.description;
                    }
                }
            }
        });
        
        let busy = (this.state.update_actionId || this.state.add_actionId);
        
        return (
            <div className="edit-rsd-modal">
                <Modal
                    show={this.props.show}
                    size="xl"
                    enforceFocus={false}
                    autoFocus
                    backdrop={false}
                    animation={false}
                    keyboard
                    onHide={this.props.closeHandler}
                >
                    <Modal.Header closeButton onHide={this.props.closeHandler}>
                        <Modal.Title>
                            {this.props.serviceData.name}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {this.state.showAddSection ? 
                        <div className="add-rsd-well">
                            <h1>Add Skill</h1>
                            <div className="row">
                                <label>Name:</label>
                                <input type='text' disabled={busy} onChange={(e)=>{this.setState({name: e.target.value})}} value={this.state.name}/>
                            </div>
                            <div className="row">
                                <label>Description:</label>
                                <input type='text' disabled={busy} onChange={(e)=>{this.setState({description: e.target.value})}} value={this.state.description}/>
                            </div>
                            <button className="btn btn-primary" title="add" disabled={busy || !this.state.name} onClick={this.addRSD}>
                                Add
                            </button>
                            <button className="btn btn-primary" title="cancel" disabled={busy} onClick={()=>{this.setState({showAddSection:false})}}>
                                Cancel
                            </button>
                        </div>
                        :
                        <button className="bare-text-button glyph fr" title="add rsd" onClick={()=>{this.setState({showAddSection:true})}}>
                            {"add skill"}<AccessibleIcon className="fa fa-plus" label="add skill"/>
                        </button>
                        }
                        <SortableTable2
                            key="rsd-table"
                            title={"RSDs for " + this.props.serviceData.name}
                            uniqueRowKey="id"
                            onRowClick={this.onRowClick}
                            rows={rows}
                            selectedRowKey={this.state.selected_rsd_id}
                            columns={[
                                {
                                    displayName: 'ID',
                                    key:'id',
                                    //size: 2,
                                    type: 'string'
                                },
                                {
                                    displayName: 'Name',
                                    key:'name',
                                    //size: 1,
                                    type: 'string'
                                },
                                {
                                    displayName: 'Description',
                                    key:'description',
                                    //size: 1,
                                    type: 'string'
                                },
                                {
                                    displayName: '',
                                    key:'dirty',
                                    //size: 1,
                                    type: 'string'
                                },
                            ]}
                            displayColumnCallbacks={{
                                id: (value,id)=>{
                                    let parts = value.split('/');
                                    return (
                                        <span title="click to copy" style={{textAlign:"right"}}>{".../" + parts[parts.length-1]}</span>
                                    );
                                },
                                name: (value,id)=>(
                                    (this.state.selected_rsd_id === id) ? 
                                    <input type='text' style={{color:'black'}} disabled={busy} value={value || ''} onChange={(e)=>{this.setRowEdit(id,'name',e.target.value)}}/>
                                    :
                                    <span>{value}</span>
                                ),
                                description: (value,id)=>(
                                    (this.state.selected_rsd_id === id) ? 
                                    <input type='text' style={{color:'black'}} disabled={busy} value={value || ''} onChange={(e)=>{this.setRowEdit(id,'description',e.target.value)}}/>
                                    :
                                    <span>{value}</span>
                                ),
                                dirty: (dirty,id)=>{
                                    if (dirty) {
                                        return ( 
                                            <div className="row-options">
                                                <button className="btn" onClick={()=>{this.saveRowEdit(id)}} disabled={busy}>save edits</button>
                                                <button className="btn" onClick={()=>{this.clearRowEdit(id)}} disabled={busy}>cancel edits</button>
                                            </div>
                                        );
                                    }
                                    else {
                                        let row_selected = (this.state.selected_rsd_id === id);
                                        if (!row_selected) {
                                            return ( 
                                                <div className="row-options">
                                                    <button className="btn" onClick={()=>{ this.setState({selected_rsd_id:id}) }} disabled={busy}>edit</button>
                                                </div>
                                            )
                                        }
                                    }
                                    return null;
                                },
                            }}
                        />
                        
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={this.props.closeHandler}>
                            close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

OrgEditRSDsModal.propTypes = propTypes;
OrgEditRSDsModal.defaultProps = defaultProps;

export default OrgEditRSDsModal;